export const SEARCHABLE_TRAILER_TYPES_FOR_ADMIN = [
	'Box',
	'Conestoga',
	'Container',
	'Double Drop',
	'Flatbed',
	'Power Only',
	'RGN',
	'Reefer',
	'Sprinter',
	'StepDeck',
	'Van',
];
